import Vue from "vue"
import Moment from "vue-moment"
import momenttimezone from "moment-timezone"

Vue.use(Moment, { moment: momenttimezone })
